import { render, staticRenderFns } from "./OwnerInsuranceActions.vue?vue&type=template&id=9c50e676&"
import script from "./OwnerInsuranceActions.vue?vue&type=script&lang=js&"
export * from "./OwnerInsuranceActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports